<div id="swipeContainer">
  <div class="head_wrap">
    <div  class="common-back-btn-sight closeBtn" (click)="close()" *ngIf="isOpenClass==0">
      <span>×</span>
    </div>

    <p class="name">{{pageTitle}}</p>
  </div>
  <div  class="surveyCard" *ngIf="surveyStatus == 1">
    <p class="surveyCardTitle textCenter">阅读说明</p>
    <p>本报告旨在<span>帮助你了解自身的能力现状和不足</span>，并提供有针对性的学习建议，需注意如下事项:</p>
    <p>如报告与自我评估有出入，请回忆是否有事情影响了你的正常发挥，例如测试动机、环境和时间等。</p>
    <p>认真阅读报告后，如有内容不能理解，请在后续学习中加强相关内容的学习以加深理解。</p>
  </div>

  <div  class="surveyCard" *ngIf="surveyStatus == 2">
    <p class="surveyCardTitle textCenter">阅读说明</p>
    <p>本报告旨在<span>帮助你明确自身的优势和不足，并为你在工作中发展该能力提供建议</span>，需注意如下事项:</p>
    <p>如报告结果与自我评估有出入，你可回忆做测验时是否有事情影响了你的正常发挥，测试动机、环境和时间都会影响测验结果。</p>
    <p>如报告与你对学习进步状况的预估不符，回忆一下对相关知识、技巧的理解是否不够透彻，或是学会的技能还没来得及在工作中实践。</p>
  </div>

  <div id="bottomSpace">
    <img class="topArrow" src="../../assets/picture/reportnew/arrow.png" alt="" >
  </div>
</div>


<div class="abilityReport" >

  <div class="experienceBtn clearfix" *ngIf="surveyStatus == 2" [ngClass]="{'slideUp': isSlide}">
    <div class="q6-icon" (click)="slideBtn()">
      <img src="../../assets/picture/experience/q6.png" alt="" >
    </div>

    <p *ngIf="showInfo"><span>收听以下音频，帮你更好了解和解读报告</span></p>
    <app-audio-play  id="audioPlay"></app-audio-play>
    <!--<app-audio-play *ngIf="showInfo"></app-audio-play>-->
  </div>


  <div class="head_wrap">
    <div class="common-back-btn-sight closeBtn" (click)="close()" *ngIf="isOpenClass==0">
      <span>×</span>
    </div>

    <p class="name">{{pageTitle}}</p>
  </div>
  <div class="surveyNav" id="surveyNav" *ngIf="surveyStatus == 1">
    <ul class="clearfix">
      <li class="active" (click)="changeTab($event)" data-target="top">能力现状</li>
      <li (click)="changeTab($event)" data-target="strongAndWeak">优势和短板</li>
      <li (click)="changeTab($event)" data-target="suggest">学习建议</li>
    </ul>
  </div>
  <div class="surveyNav" id="surveyNav" *ngIf="surveyStatus == 2">
    <ul class="clearfix">
      <li class="active" (click)="changeTab($event)" data-target="top">考核结果</li>
      <li (click)="changeTab($event)" data-target="compare">前后对比</li>
      <li (click)="changeTab($event)" data-target="suggest">发展建议</li>
    </ul>
  </div>

  <div class="abilityFrontTest abilityBody" (scroll)="elementScroll($event)" *ngIf="surveyStatus == 1">

    <div class="surveyItemCard" id="firstSection">
      <p class="surveyItemCardTitle top" >能力现状</p>
      <div class="cardContainer chartsForm">
          <img src="../../assets/picture/reportnew/chartBG.png"  class="chartBG" alt="" />
          <div class="scaleTxt">
              <p [ngClass]='{"c1":level == 1}'>薄弱</p>
              <p [ngClass]='{"c2":level == 2}'>有限</p>
              <p [ngClass]='{"c3":level == 3}'>一般</p>
              <p [ngClass]='{"c4":level == 4}'>良好</p>
              <p [ngClass]='{"c5":level == 5}'>优秀</p>
              <p [ngClass]='{"c6":level == 6}'>卓越</p>
          </div>
          <div class="" id="circleCharts"></div>
          <img src="{{faceUrl}}" class="face" alt="">
          <div class="transparentCard" *ngIf="levelDesc">
            总体表现：{{levelDesc}}
          </div>
      </div>
    </div>

    <div class="surveyItemCard" id="secondSection">
      <p class="surveyItemCardTitle strongAndWeak">优势和短板</p>
      <div class="cardContainer">
        <ul class="clearfix">
          <li class="active strong" (click)="showStrong()" >优势</li>
          <li class="weak" (click)="showWeak()">短板</li>
        </ul>
        <div class="cardContent">
          <div  class="shortTxt">
            <ul>
              <li *ngFor="let item of short; let i =index">{{short[i]}}</li>
            </ul>
          </div>

          <div  class="strongTxt">
            <ul>
              <li *ngFor="let item of advantages; let i =index">{{advantages[i]}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="surveyItemCard" id="thirdSection">
      <p class="surveyItemCardTitle suggest">学习建议</p>
      <div class="cardContainer">
        <div class="inlineCard">
					<div class="inlineCardTop_div">
						<div class="img_div">
							<img src="../../assets/picture/reportnew/teacherMindy.png" alt="" *ngIf="courseName!='打造高效团队'&&courseName!='领导力精要'&&courseName!='协作'&&courseName!='计划与组织'&&courseName!='影响力'&&courseName!='领导力启程'&&courseName!='驱动变革'&&courseName!='解决冲突'">
							<img src="../../assets/picture/reportnew/teacherAlex.png" alt=""  *ngIf="courseName=='打造高效团队'||courseName=='解决冲突'">
							<img src="../../assets/picture/reportnew/teacherRita.png" alt=""  *ngIf="courseName=='领导力精要'||courseName=='领导力启程'">
							<img src="../../assets/picture/reportnew/teacherMike.png" alt=""  *ngIf="courseName=='协作'">
							<img src="../../assets/picture/reportnew/teacherLilith.png" alt=""  *ngIf="courseName=='计划与组织'">
							<img src="../../assets/picture/reportnew/reportTeacher.png" alt=""  *ngIf="courseName=='影响力'||courseName=='驱动变革'">
						</div>
						<div class="con_title">在后续的课程学习中，你可以重点关注以下内容：</div>
					</div>
					<div class="inlineCardTop_s"></div>
					<div class="list_div clearfix">
						<div class="list_li" *ngFor="let item of learningTips;let i =index">
              <div class="inlineCardBottom_title"><span *ngIf="item.title">{{i+1}}、</span>{{item.title}}</div>
							<div class="inlineCardBottom_con">{{item.content}}</div>
					  </div>
					</div>
<!--          <div class="inlineCardTop">{{item.title}}</div>
          <div class="inlineCardBottom clearfix">
            <img src="../../assets/picture/reportnew/teacherMindy.png" alt="" *ngIf="courseName!='打造高效团队'&&courseName!='领导力精要'&&courseName!='协作'&&courseName!='计划与组织'&&courseName!='影响力'&&courseName!='领导力启程'&&courseName!='驱动变革'">
            <img src="../../assets/picture/reportnew/teacherAlex.png" alt=""  *ngIf="courseName=='打造高效团队'">
            <img src="../../assets/picture/reportnew/teacherRita.png" alt=""  *ngIf="courseName=='领导力精要'||courseName=='领导力启程'">
            <img src="../../assets/picture/reportnew/teacherMike.png" alt=""  *ngIf="courseName=='协作'">
            <img src="../../assets/picture/reportnew/teacherLilith.png" alt=""  *ngIf="courseName=='计划与组织'">
            <img src="../../assets/picture/reportnew/reportTeacher.png" alt=""  *ngIf="courseName=='影响力'||courseName=='驱动变革'">
            <p >{{item.content}}</p>
          </div> -->
        </div>
      </div>
    </div>
    <p class="bottomBtnTitle">{{surveyTutor}}</p>
    <div class="bottomBtn" *ngIf="isOpenClass==0" (click)="getCourse()">进入课程学习</div>
  </div>

  <div class="abilityAfterTest abilityBody" (scroll)="elementScroll($event)" *ngIf="surveyStatus == 2">
    <div class="surveyItemCard" id="firstSection">
      <p class="surveyItemCardTitle top" >考核结果</p>
      <div class="cardContainer chartsForm">
        <img src="../../assets/picture/reportnew/chartBG.png"  class="chartBG" alt="" />
        <div class="scaleTxt">
          <p [ngClass]='{"c1":level == 1}'>薄弱</p>
          <p [ngClass]='{"c2":level == 2}'>有限</p>
          <p [ngClass]='{"c3":level == 3}'>一般</p>
          <p [ngClass]='{"c4":level == 4}'>良好</p>
          <p [ngClass]='{"c5":level == 5}'>优秀</p>
          <p [ngClass]='{"c6":level == 6}'>卓越</p>
        </div>
        <div class="" id="circleCharts"></div>
        <img src="{{faceUrl}}" class="face" alt="">
        <div class="transparentCard" *ngIf="levelDesc">
          总体表现：{{levelDesc}}
        </div>
      </div>
    </div>
    <div class="surveyItemCard"  id="secondSection">
      <p class="surveyItemCardTitle compare">前后对比</p>
      <div class="cardContainer">
        <div class="transparentCard">
          <div *ngIf="report != null && report.contrastDesc != null">{{report.contrastDesc}}</div>
        </div>

        <div class="tableCard">
            <div class="tableCardTr">
              <div class="tableCardTd borderRadiusTopLeft">能力诊断</div>
              <div class="tableCardTd borderRadiusTopRight">能力考核</div>
            </div>
            <div class="tableCardTr">
              <div class="tableCardTd c{{beforeLevel}}"><span class="iconCircle bg{{beforeLevel}}">L{{beforeLevel}}</span> {{beforeLevelName}}</div>
              <div class="tableCardTd c{{afterLevel}}" ><span class="iconCircle bg{{afterLevel}}">L{{afterLevel}}</span>  {{afterLevelName}}</div>
            </div>
          <div class="tableCardTr">
            <div class="tableCardTd">{{beforeLevelDesc}}</div>
            <div class="tableCardTd">{{afterLevelDesc}}</div>
          </div>

          <div class="tableCardTr">
            <div class="tableCardTd" [innerHtml]="beforeLevelAdvantages"></div>
            <div class="tableCardTd" [innerHtml]="afterLevelAdvantages"></div>
          </div>

          <div class="tableCardTr">
            <div class="tableCardTd borderRadiusBottomRight" [innerHtml]="beforeLevelShort"></div>
            <div class="tableCardTd borderRadiusBottomLeft" [innerHtml]="afterLevelShort"></div>
          </div>
        </div>

      </div>
    </div>
    <div class="surveyItemCard" id="thirdSection">
      <p class="surveyItemCardTitle suggest">发展建议</p>
      <div class="cardContainer">
        <div class="blockCard" *ngIf="developmentTips" [innerHtml]="developmentTips">

        </div>
      </div>
    </div>
    <div class="bottomBtn" id="afterTestBtn" (click)="finishCourse()" *ngIf="isOpenClass==0">返回英跃学堂</div>
  </div>


</div>



// WEBPACK FOOTER //
// ./src/app/ability-report/ability-report.component.html